// Port of api/fuel/app/classes/filter/search/games/filters/query/source.php
import F from 'offline/filter/constants'
export default {
	name: 'source',
	priority: 1,
	require: function(config, filter) {
		if (!filter.source) return false
		return filter.source.all || filter.source.collection || filter.source.plays || filter.source.ratings || filter.source.list || filter.source['list.sorted']
	},
	run: function(config, filter, data, query) {
		var sourceKeys = Object.keys(filter.source || {})
		for (var i = 0; i < sourceKeys.length; i++) {
			var key = sourceKeys[i]
			if (!filter.source[key] || !F.SOURCE_TABLE[key]) continue
			var table = F.SOURCE_TABLE[key]
			var relation = F.TABLE_RELATION[table]
			if (relation) query.source(table, relation)
		}
	}
}
